module.exports = "<div class=\"donutChart\">\r\n  <canvas #PieChartID id=\"PieChartID\" class=\"col-12 p-0\">\r\n    \r\n  </canvas>\r\n</div>"